import moment from "moment";
import { Fragment } from "react";
import { DatePicker, Grid, Input, Loader, Modal, PhoneInput, Switch } from "../../../components";
import { COMPANY_OPTIONS_SORTED } from "../../../constants";
import { formatCPF } from "../../../utils";
import { isSmilesFamilyCompany } from "@next-pontos/validations";
import { FormikProps } from "formik";
import { Tooltip as MuiTooltip } from "@mui/material";


type CreateAccountModalProps = {
    isModalOpen: boolean;
    modalVisibilityControls: {
      setFalse: () => void;
    };
    accountLoading: boolean;
    formik: FormikProps<{
      company: string;
      is_membership_active: boolean;
      holder_name: string;
      holder_email: string;
      holder_birthday: string
      membership_number: string;
      holder_cpf: string;
      holder_phone_number: string;
      login: string;
      password: string;
    }>;
  };
  
export const CreateAccountModal: React.FC<CreateAccountModalProps> = ({
  isModalOpen,
  modalVisibilityControls,
  accountLoading,
  formik: createAccountFormik,
}) => {
  return (
    <Modal
                open={isModalOpen}
                onClose={modalVisibilityControls.setFalse}
                title="Criar Conta"
                onConfirm={accountLoading ? undefined : createAccountFormik.handleSubmit}
                confirmLabel="Salvar"
                bodyCustomCss={{
                    minWidth: 400,
                    maxHeight: '60vh',
                    overflow: 'auto'
                }}
            >
                <Grid container padding={2} spacing={2} justifyContent="center">
                    {accountLoading ? (
                        <Grid item xs={12} textAlign={"center"}>
                            <Loader />
                        </Grid>
                    ) : (<Fragment>
                        <Grid item xs={12} sm={6}> 
                            <MuiTooltip title="Você apenas pode adicionar contas para suas ofertas aceitas." placement="top">
                                <Input 
                                    label="Companhia"
                                    name="company"
                                    select
                                    options={COMPANY_OPTIONS_SORTED}
                                    onChange={createAccountFormik.handleChange}
                                    onBlur={createAccountFormik.handleBlur}
                                    value={createAccountFormik.values.company}
                                    helperText={createAccountFormik.touched.company && createAccountFormik.errors.company}
                                    error={!!createAccountFormik.touched.company && !!createAccountFormik.errors.company}
                                />
                            </MuiTooltip>
                        </Grid>
                        <Grid item xs={12} sm={6} display="flex" alignItems="center" justifyContent="center"> 
                            <Switch
                                label="Possui clube ativo?"
                                checked={createAccountFormik.values.is_membership_active}
                                onChange={() => {
                                    createAccountFormik.setFieldValue('is_membership_active', !createAccountFormik.values.is_membership_active, false)
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}> 
                            <Input 
                                label="Nome do Titular"
                                name="holder_name"
                                onChange={createAccountFormik.handleChange}
                                onBlur={createAccountFormik.handleBlur}
                                value={createAccountFormik.values.holder_name}
                                helperText={createAccountFormik.touched.holder_name && createAccountFormik.errors.holder_name}
                                error={!!createAccountFormik.touched.holder_name && !!createAccountFormik.errors.holder_name}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}> 
                            <Input 
                                label="E-mail do Titular"
                                name="holder_email"
                                onChange={createAccountFormik.handleChange}
                                onBlur={createAccountFormik.handleBlur}
                                value={createAccountFormik.values.holder_email}
                                helperText={createAccountFormik.touched.holder_email && createAccountFormik.errors.holder_email}
                                error={!!createAccountFormik.touched.holder_email && !!createAccountFormik.errors.holder_email}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <DatePicker
                                label="Data de Nascimento do Titular"
                                value={createAccountFormik.values.holder_birthday ? moment(createAccountFormik.values.holder_birthday) : null}
                                onChange={(value) => {
                                    createAccountFormik.setFieldValue('holder_birthday', value?.toDate(), true)
                                }}
                                helperText={createAccountFormik.touched.holder_birthday && createAccountFormik.errors.holder_birthday}
                                error={!!createAccountFormik.touched.holder_birthday && !!createAccountFormik.errors.holder_birthday}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}> 
                            <MuiTooltip
                                title="Preencha este campo com o número de fidelidade da companhia. Caso não haja preencha com o CPF."
                            >
                                <Input 
                                    label="Número de Fidelidade"
                                    name="membership_number"
                                    onChange={createAccountFormik.handleChange}
                                    onBlur={createAccountFormik.handleBlur}
                                    value={createAccountFormik.values.membership_number}
                                    helperText={createAccountFormik.touched.membership_number && createAccountFormik.errors.membership_number}
                                    error={!!createAccountFormik.touched.membership_number && !!createAccountFormik.errors.membership_number}
                                />
                            </MuiTooltip>
                        </Grid>
                        <Grid item xs={12} sm={6}> 
                            <Input 
                                label="CPF do Titular"
                                name="holder_cpf"
                                onChange={({target}) => {
                                    createAccountFormik.setFieldValue('holder_cpf', formatCPF(target.value))
                                }}
                                onBlur={createAccountFormik.handleBlur}
                                value={createAccountFormik.values.holder_cpf}
                                helperText={createAccountFormik.touched.holder_cpf && createAccountFormik.errors.holder_cpf}
                                error={!!createAccountFormik.touched.holder_cpf && !!createAccountFormik.errors.holder_cpf}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}> 
                            <PhoneInput
                                label="Telefone do Titular"
                                inputProps={{
                                    name: 'holder_phone_number'
                                }}
                                onChange={value => {
                                    createAccountFormik.setFieldValue('holder_phone_number', value, true)
                                }}
                                value={createAccountFormik.values.holder_phone_number}
                                // helperText={formik.touched.phone_number && formik.errors.phone_number}
                                onBlur={createAccountFormik.handleBlur}
                                error={!!createAccountFormik.touched.holder_phone_number && !!createAccountFormik.errors.holder_phone_number}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}> 
                            <Input 
                                label="Login"
                                name="login"
                                onChange={createAccountFormik.handleChange}
                                onBlur={createAccountFormik.handleBlur}
                                value={createAccountFormik.values.login}
                                helperText={createAccountFormik.touched.login && createAccountFormik.errors.login}
                                error={!!createAccountFormik.touched.login && !!createAccountFormik.errors.login}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}> 
                            <Input 
                                label="Senha do Programa de Fidelidade"
                                name="password"
                                type="password"
                                onChange={createAccountFormik.handleChange}
                                onBlur={createAccountFormik.handleBlur}
                                value={createAccountFormik.values.password}
                                helperText={createAccountFormik.touched.password && createAccountFormik.errors.password}
                                error={!!createAccountFormik.touched.password && !!createAccountFormik.errors.password}
                                inputProps={isSmilesFamilyCompany(createAccountFormik.values.company) ? { inputMode: 'numeric', maxLength: 4 } : undefined}
                            />
                        </Grid>
                    </Fragment>)}
                </Grid>
    </Modal>
  );
};
